<div class="markdown-editor">
    <div class="editor-toolbar">
        <div class="editor-tabs">
            <button type="button" class="editor-tab" [class.active]="activeEditorTab === 'write'"
                (click)="setEditorTab('write', $event)">Write</button>
            <button type="button" class="editor-tab" [class.active]="activeEditorTab === 'preview'"
                (click)="setEditorTab('preview', $event)">Preview</button>
        </div>
        <div class="toolbar-actions">
            <button type="button" class="toolbar-btn" [disabled]="disabled"
                (click)="insertMarkdownBlock('# ', 'Heading 1')">H1</button>
            <button type="button" class="toolbar-btn" [disabled]="disabled"
                (click)="insertMarkdownBlock('## ', 'Heading 2')">H2</button>
            <button type="button" class="toolbar-btn" [disabled]="disabled"
                (click)="insertMarkdownBlock('### ', 'Heading 3')">H3</button>
            <button type="button" class="toolbar-btn fw-bold" [disabled]="disabled"
                (click)="applyMarkdown('**', '**', 'bold text')">B</button>
            <button type="button" class="toolbar-btn fst-italic" [disabled]="disabled"
                (click)="applyMarkdown('*', '*', 'italic text')">I</button>
            <button type="button" class="toolbar-btn" [disabled]="disabled"
                (click)="insertMarkdownBlock('- ', 'List item')">
                <i class="fa fa-list-ul"></i>
            </button>
            <button type="button" class="toolbar-btn" [disabled]="disabled"
                (click)="insertMarkdownBlock('1. ', 'List item')">
                <i class="fa fa-list-ol"></i>
            </button>
            <button type="button" class="toolbar-btn" [disabled]="disabled"
                (click)="applyMarkdown('[', '](https://example.com)', 'link text')">
                <i class="fa fa-link"></i>
            </button>
            <button type="button" class="toolbar-btn" [disabled]="disabled" (click)="undoDescription()">
                <i class="fa fa-undo"></i>
            </button>
        </div>
    </div>

    <div class="editor-body" [class.preview-mode]="activeEditorTab === 'preview'">
        <textarea
            *ngIf="activeEditorTab === 'write'"
            #descriptionTextarea
            class="markdown-textarea"
            rows="8"
            [placeholder]="placeholder"
            [value]="value"
            [disabled]="disabled"
            (input)="onDescriptionInput($event)"
            (blur)="onBlur()"></textarea>

        <div
            *ngIf="activeEditorTab === 'preview'"
            class="markdown-preview"
            [innerHTML]="previewContent"></div>
    </div>
</div>
